export function buildUrl(urlParts) {
    if (!urlParts || !Array.isArray(urlParts)) {
        return '';
    }

    // remove all empty parts and trim all leading and trailing slashes
    // then join the parts with a single slash
    return urlParts = urlParts.map((part, index) => {
        // if the first part starts with a protocol (e.g., http://) or starts with '//' which is also valid for protocol-relative URLs and preserve it as is, but trim the trailing slashes
        if (index === 0 && (part.includes('://') || part.startsWith('//'))) {
            return part.trim().replace(/\/+$/g, '');
        }

        return part.trim().replace(/^\/+|\/+$/g, '');
    }).filter(part => part).join('/');
}